// Environment configuration utility
// Vite uses import.meta.env instead of process.env

export const env = {
  // API Configuration
  API_URL: import.meta.env.VITE_API_URL || import.meta.env.VITE_APP_API_URL || 'http://localhost:8080',
  API_VERSION: import.meta.env.VITE_API_VERSION || import.meta.env.VITE_APP_API_VERSION || 'v1',
  // Public API base URL — distinct from `API_URL` because the public
  // surface (`/public/v1/...`) is mounted on the API host root and
  // does NOT live behind the `mobile-app-api/v1` prefix that the main
  // app uses. Carrying its own env var lets each environment point
  // local-dev → localhost, dev → api-dev, prd → api production, and
  // avoids hacks like stripping the path off `API_URL`.
  PUBLIC_API_URL: import.meta.env.VITE_PUBLIC_API_URL || import.meta.env.VITE_APP_PUBLIC_API_URL || 'http://localhost:8080',

  // App Configuration
  APP_URL: import.meta.env.VITE_APP_URL || import.meta.env.VITE_APP_APP_URL || 'http://localhost:3001',
  APP_NAME: import.meta.env.VITE_APP_NAME || import.meta.env.VITE_APP_APP_NAME || 'Meiuca App',

  // Site URLs
  SITE_URL: import.meta.env.VITE_SITE_URL || import.meta.env.VITE_APP_SITE_URL || 'http://localhost:3000',

  // External URLs
  SUPPORT_URL: import.meta.env.VITE_SUPPORT_URL || import.meta.env.VITE_APP_SUPPORT_URL || 'mailto:suporte@meiuca.app',
  PRIVACY_URL: import.meta.env.VITE_PRIVACY_URL || import.meta.env.VITE_APP_PRIVACY_URL || 'http://localhost:3000/privacidade',
  TERMS_URL: import.meta.env.VITE_TERMS_URL || import.meta.env.VITE_APP_TERMS_URL || 'http://localhost:3000/termos',

  // Google APIs
  GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',

  // Environment
  IS_DEVELOPMENT: import.meta.env.DEV,
  IS_PRODUCTION: import.meta.env.PROD,
} as const

// Validation helper
export function validateEnv() {
  const missing: string[] = []

  if (!env.API_URL || env.API_URL === 'http://localhost:8080') {
    missing.push('VITE_API_URL')
  }

  if (!env.GOOGLE_MAPS_API_KEY) {
    missing.push('VITE_GOOGLE_MAPS_API_KEY')
  }

  if (missing.length > 0) {
    console.warn(
      `⚠️ Missing or using default values for environment variables: ${missing.join(', ')}`
    )
  }

  return missing.length === 0
}

// API endpoints builder
export const apiEndpoints = {
  auth: {
    login: `${env.API_URL}/auth/sign-in`,
    signup: `${env.API_URL}/auth/sign-up`,
    logout: `${env.API_URL}/auth/logout`,
    refresh: `${env.API_URL}/auth/refresh-token`,
    profile: `${env.API_URL}/auth/profile`,
    resetPassword: `${env.API_URL}/auth/reset-password`,
    challengesPhone: `${env.API_URL}/auth/challenges/phone`,
    challengesPhoneVerify: `${env.API_URL}/auth/challenges/phone/verify`,
    challengesPhoneResend: `${env.API_URL}/auth/challenges/phone/resend`,
  },
  user: {
    profile: `${env.API_URL}/api/${env.API_VERSION}/user/profile`,
    updateProfile: `${env.API_URL}/api/${env.API_VERSION}/user/profile`,
  },
  games: {
    list: `${env.API_URL}/api/${env.API_VERSION}/games`,
    create: `${env.API_URL}/api/${env.API_VERSION}/games`,
    join: (id: string) => `${env.API_URL}/api/${env.API_VERSION}/games/${id}/join`,
    leave: (id: string) => `${env.API_URL}/api/${env.API_VERSION}/games/${id}/leave`,
  }
} as const